module.exports = _.intersection;